import MonthImg from './imgs/icon-month@2x.png';
import YearImg from './imgs/icon-year@2x.png';

export const getPieChartOption = (chartData?: { name: string; num: number }[], isYear?: boolean) => {
  return {
    color: ['#52E7FF', '#FFCB47', '#2D8DFF', '#854ECA', '#ABD335', '#FF9247', '#FF477B'],
    graphic: {
      elements: [
        {
          type: 'image',
          style: {
            image: !isYear ? MonthImg : YearImg,
            x: 10,
            y: 10,
            width: 34,
            height: 34,
          },
        },
      ],
    },
    series: [
      {
        type: 'pie',
        name: '总故障数',
        radius: [25, 28],
        width: 56,
        height: 56,
        label: {
          show: false,
        },
        emphasis: {
          scale: false,
        },
        data: (chartData ?? []).map(item => ({
          name: item.name,
          value: item.num,
        })),
        showEmptyCircle: false,
      },
    ],
  };
};
